import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import ContactForm from './ContactForm';
import { X } from 'lucide-react';

const ContactModal = ({ isOpen, onClose }) => {
  const backdropAnimation = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const modalAnimation = {
    hidden: { opacity: 0, scale: 0.9, y: 50 },
    show: { 
      opacity: 1, 
      scale: 1, 
      y: 0,
      transition: {
        type: 'spring',
        damping: 25,
        stiffness: 300,
      }
    },
    exit: { opacity: 0, scale: 0.9, y: 50 },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 bg-black/90 backdrop-blur-xl z-40"
            variants={backdropAnimation}
            initial="hidden"
            animate="show"
            exit="exit"
            onClick={onClose}
          />
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none"
            variants={backdropAnimation}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            <motion.div
              className="bg-background/95 backdrop-blur-2xl border border-border rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden pointer-events-auto ring-1 ring-white/10"
              variants={modalAnimation}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sticky top-0 bg-background/80 backdrop-blur-2xl border-b border-border px-6 py-5 flex justify-between items-center">
                <div>
                  <h3 className="text-xl font-semibold text-foreground">프로젝트 문의</h3>
                  <p className="text-sm text-muted-foreground mt-1">24시간 이내 답변드립니다</p>
                </div>
                <button
                  onClick={onClose}
                  className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="overflow-y-auto max-h-[calc(90vh-80px)]">
                <ContactForm />
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContactModal;